import { render, staticRenderFns } from "./ForgotSuccessView.vue?vue&type=template&id=9fe349b2"
import script from "./ForgotSuccessView.vue?vue&type=script&lang=js"
export * from "./ForgotSuccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports